import { render, staticRenderFns } from "./InterventionDashboard.vue?vue&type=template&id=13b6a179"
import script from "./InterventionDashboard.vue?vue&type=script&lang=ts"
export * from "./InterventionDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports